import { render, staticRenderFns } from "./DataPesertaDokumenNew.vue?vue&type=template&id=5a0ada3a&"
import script from "./DataPesertaDokumenNew.vue?vue&type=script&lang=js&"
export * from "./DataPesertaDokumenNew.vue?vue&type=script&lang=js&"
import style0 from "./DataPesertaDokumenNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports